import moment from 'moment';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchTechPack = (id) => async (dispatch) => {
	let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
	await ApiClient.GET('getTechPackPages', id + '?currentTime=' + currentTime).then(async (response) => {
		await dispatch({
			type: Types.FETCH_TECHPACK,
			payload: response.data
		});
	});
};

export const fetchPublicTechpack = (id, setRemainingTime, updateHasError) => async (dispatch) => {
	let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
	await ApiClient.GET('getPublicTechPackPages', id + '?currentTime=' + currentTime)
		.then(async (response) => {
			await dispatch({
				type: Types.FETCH_TECHPACK,
				payload: response.data.htmlContent
			});
			setRemainingTime(response.data.totalRemainingSecond);
		})
		.catch(() => updateHasError(true));
};
